export default "__VITE_ASSET__iHKZVt8___"